module.exports = __webpack_public_path__ + "static/img/nurhayati.b323b19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonial/nurhayati.jpg
// module id = 3DA8
// module chunks = 1